export const exportRegionalData = `query ($filter: ExportRegionalRequest){
    exportRegional(filter: $filter) {
            name,
            content
        }
    }`;
